import { ChatOutlinedIcon } from '../../../../components';

interface EmptyReviewStateProps {
  message: string;
}

export default function EmptyReviewState(props: Readonly<EmptyReviewStateProps>) {
  const { message } = props;

  return (
    <div className='flex w-full flex-col items-center gap-4 rounded-2xl border border-dashed border-gray-300 bg-gray-50 py-6'>
      <ChatOutlinedIcon className='text-text-secondary text-5xl' />
      <h4 className='text-text-primary'>{message}</h4>
    </div>
  );
}
